import { eventFiltersTypes } from './eventFiltersTypes';

export const titleByEventFilter = {
  [eventFiltersTypes.CREDIT_ANALYSIS]: 'Credit Analysis',
  [eventFiltersTypes.ESG_ANALYSIS]: 'ESG Analysis',
  [eventFiltersTypes.FUNDS_ANALYSIS]: 'Funds Analysis',
};
